export default __webpack_public_path__ + "static/media/Illustration-about.7631b5c4.svg";